import React from 'react'

import Base from '../_Base'

const Add = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <polygon points="13 3 13 11 21 11 21 13 13 13 13 21 11 21 11 13 3 13 3 11 11 11 11 3" />
  </Base>
)

export default Add
